import { TaskInfo } from './task-info';
import { ICodeExecutor } from './icode-executor';
import { IDisposableAsync } from '../../misc/interfaces/idisposable';
import { IO2Cloud } from './io2-cloud';

export abstract class ICodeExecutorFactory extends IDisposableAsync {
    public abstract getExecutor(task: TaskInfo, cloud: IO2Cloud): ICodeExecutor;
}
